// src/lib/networkTracker.js
// Counts in-flight HTTP requests (axios + fetch). The board pack render page
// uses it to know when every page has finished loading its data.
import axios from "axios";

const state = { inflight: 0, started: 0, finished: 0, lastChange: Date.now() };
let installed = false;

const begin = () => {
  state.inflight += 1;
  state.started += 1;
  state.lastChange = Date.now();
};

const end = () => {
  state.inflight = Math.max(0, state.inflight - 1);
  state.finished += 1;
  state.lastChange = Date.now();
};

export const installNetworkTracker = () => {
  if (installed) return state;
  installed = true;

  axios.interceptors.request.use((config) => {
    begin();
    config.__tracked = true;
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      if (response?.config?.__tracked) end();
      return response;
    },
    (error) => {
      if (error?.config?.__tracked) end();
      return Promise.reject(error);
    }
  );

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    begin();
    try {
      return await originalFetch(...args);
    } finally {
      end();
    }
  };

  return state;
};
